import React, { useEffect, useState, Component } from "react";
import Typography from "@mui/material/Typography";
import { Button, Row, Col, Form, Alert, Modal } from "react-bootstrap";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Link, useHistory } from "react-router-dom";
import { without, filter } from "lodash";
import Select from "react-select";
import CheckRole from "../CheckRole.js";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';
//Librerias de la tabla
import { lighten } from "@mui/material/styles";
import withStyles from "@mui/styles/withStyles";
import makeStyles from "@mui/styles/makeStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Checkbox } from "@mui/material";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";

import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";
import Toolbar from "@mui/material/Toolbar";
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import AADService from "../funcionesAuth.js";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";

//Finaliza las librerias de la tabla
function AlertDismissibleExample({ alerta }) {
  switch (alerta) {
    case 1:
      return <Alert variant="warning">Alerta</Alert>;
      break;
    case 2:
      return <Alert variant="success">Guardó exitosamente</Alert>;
      break;
    case 3:
      return <Alert variant="danger"></Alert>;
      break;
    case 4:
      return <Alert variant="warning">Error al enviar la información</Alert>;
      break;
    case 5:
      return <Alert variant="danger">Error en el servidor</Alert>;
      break;
    case 6:
      return (
        <Alert variant="warning">
          Ya existe una evaluación para el activo seleccionado
        </Alert>
      );
      break;
    default:
      return <p></p>;
      break;
  }
}
//procesos header
const headCellsProcesos = [
  {
    id: "idsubproceso",
    numeric: false,
    disablePadding: true,
    label: "Id Subproceso",
  },
  {
    id: "macroproceso",
    numeric: false,
    disablePadding: false,
    label: "macroproceso",
  },
  { id: "proceso", numeric: false, disablePadding: false, label: "proceso" },
  {
    id: "subproceso",
    numeric: false,
    disablePadding: false,
    label: "subproceso",
  },
  { id: "estado", numeric: false, disablePadding: false, label: "estado" },
];
//activos header
const headCells = [
  { id: "id", numeric: false, disablePadding: true, label: "ID" },
  { id: "nombre", numeric: false, disablePadding: false, label: "Nombre" },
  {
    id: "descripcion",
    numeric: false,
    disablePadding: false,
    label: "Descripción",
  },
];
//////////////////////Tabla dentro del Modal
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHeadProcesos(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCellsProcesos.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
EnhancedTableHeadProcesos.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    //paddingLeft: theme.spacing(2),
    //paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.mode === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: "1 1 100%",
  },
}));
//////////////////////Fin Tabla dentro del Modal
const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Evaluaciones
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete" size="large">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton aria-label="filter list" size="large">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStylesModal = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    //marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  container: {
    maxHeight: "55vh",
    minHeight: "55vh",
  },
}));
//////////////////////Fin Tabla dentro del Modal

//Empieza tabla de activos
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#2c2a29",

    color: "white",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#f4f4f4",
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});
const stylesSelect = {
  control: (base) => ({
    ...base,
    fontFamily: "Roboto",
  }),
  menu: (base) => ({
    ...base,
    fontFamily: "CIBFont Sans Regular",
  }),

  option: (provided, state) => ({
    ...provided,
    //color: state.isFocused ? 'white' : '#495057',
  }),
};
//Finaliza tabla de activos

const EditarComponente = () => {
  const classes = useStyles();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowProcesos, setModalShowProcesos] = React.useState(false);
  const [activo, setActivo] = React.useState([]);
  const [companiaDat, setCompaniaDat] = React.useState([]);
  const [usuariosDatNeg, setUsuariosDatNeg] = React.useState([]);
  const [usuariosDatTI, setUsuariosDatTI] = React.useState([]);
  const [state, setState] = useState("");
  const [idState, setIdState] = useState(false);
  const [vRequired, setVRequired] = useState(true);
  const [modalInfo, setModalInfo] = React.useState([]);
  const [estadoPOST, setEstadoPost] = React.useState(0);
  //////////////////////Constantes datos selects
  const [selectedValueCompania, setSelectedValueCompania] = useState(null);
  const [selectedValueResponsableTI, setSelectedValueResponsableTI] =
    useState(null);
  const [selectedValueResponsableNeg, setSelectedValueResponsableNeg] =
    useState(null);
  ///////////////////////////////
  let history = useHistory();
  const [validated, setValidated] = useState(false);
  const [clasi, setClasi] = useState([]);
  const [nvCriticidad, setNvCriticidad] = useState("No Clasificado");
  //////////////////////////////datos tablas
  const [rowsc, setRowsC] = React.useState([]);
  const [rowsCompInit, setRowsCompInit] = React.useState([]);
  const [rowsP, setRowsP] = React.useState([]);
  const [rowsProcInit, setRowsProcInit] = React.useState([]);
  const [procesosSelected, setProcesosSelected] = React.useState([]);
  const [componentesSelected, setComponentesSelected] = React.useState([]);
  //////////////////////Constante Datos Tabla Modal
  const [modalCompo, setModalCompo] = useState([]);
  const [datContenidos, setDatContenidos] = React.useState([]);

  /////////// Check Role
  const check = new CheckRole("/EditarActivo");
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);

  const [activoUnico, setActivoUnico] = useState(null);
  const [activoAuditable, setActivoAuditable] = useState(null);
  const [atributos, setAtributos] = useState([1, 2, 3, 4, 5]);
  const [valores, setValores] = React.useState({});
  const [valoresPDP, setValoresPDP] = React.useState({});
  const [errors, setErrors] = React.useState({});
  const [dominio, setDominio] = useState("");
  const [errorDominio, setErrorDominio] = useState(false);
  const [errorResponsableTI, setErrorResponsableTI] = useState(false);
  const [nameCompa, setNameCompa] = React.useState("");
  const [errorNombreActivo, setErrorNombreActivo] = useState(false);
  const [errorCompania, setErrorCompania] = useState(false);
  // const [errorResponsableNeg, setErrorResponsableNeg] = useState(false);
  const [errorActivoUnico, setErrorActivoUnico] = useState(false);
  const [errorActivoAuditable, setErrorActivoAuditable] = useState(false);
  const [confidencialidad, setConfidencialidad] = useState(null);
  const [disponibilidad, setDisponibilidad] = useState(null);
  const [integridad, setIntegridad] = useState(null);

  const [companiaSelect, setCompaniaSelect] = useState(null);
  const [responsableTI, setresponsableTI] = useState(null);

  const [direccion, setDireccion] = React.useState(false);
  const [errorAplicaciones, setErrorAplicaciones] = useState(false);
  const [confi, setConfi] = useState("");
  const [dispo, setDispo] = useState("");
  const [integri, setIntegri] = useState("");
  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [opcionesDominio, setOpcionesDominio] = useState("");
  const [clasificacionCargada, setClasificacionCargada] = useState(false);
  const [componentesRelacionados, setComponentesRelacionados] = useState([]);



  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const [dominioPlace, setDominioPlace] = useState([]);

  const eliminarAtributo = (num) => {
    setAtributos((prev) => prev.filter((n) => n !== num));
  };

  const opcionesConfidencialidad = [
    { value: "No clasificado", label: "No Clasificado" },
    { value: "Restringida", label: "Restringida" },
    { value: "Confidencial", label: "Confidencial" },
    { value: "Interna", label: "Interna" },
    { value: "Pública", label: "Pública" },
  ];

  const opcionesClasificacion = [
    { value: "No clasificado", label: "No Clasificado" },
    { value: "Crítico", label: "Crítico" },
    { value: "Moderado", label: "Moderado" },
    { value: "Tolerable", label: "Tolerable" },
    { value: "Bajo", label: "Bajo" },
  ];

  const agregarAtributo = () => {
    setAtributos([...atributos, atributos.length + 1]);
  };

  const onChangeResponsableTI = (value) => {
    const id = value?.idposicion || null;
    setresponsableTI(id);
    if (id) {
      setErrorResponsableTI(false);
    }
  };

  // const onChangeResponsableNeg = (value) => {
  //   setresponsableNeg(value.idposicion);
  // };

  const onChangeCompania = (value) => {
    setCompaniaSelect(value.idcompania);
  };
  const crear_com = (event) => {
    var button = document.getElementById("send");
    //button.form.submit();
    //alert(button)
    button.click();
    setModalShow(false);
  };
  function cprincipal(componente_principal) {
    if (componente_principal === 1) {
      return "Principal";
    } else if (componente_principal === 2) {
      return "Módulo";
    } else if (componente_principal === 3) {
      return "Infraestructura";
    } else {
      return "Valor no reconocido";
    }
  }

  //Retorna el nombre de la compañía segun id
  function bCompania(id) {
    for (const clave in nameCompa) {
      if (id == nameCompa[clave]["idcompania"]) {
        return nameCompa[clave]["compania"];
      }
    }
    return "No Existe";
  }

  useEffect(() => {
    //////////////////////Datos del JSON

    const obtenerInformacionCompleta = async () => {
      try {
        const idactivo = localStorage.getItem("idactivo");

        const response = await fetch(
          process.env.REACT_APP_API_URL +
          "evaluacion/infoCompletaActivos/" +
          idactivo +
          "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            "Error al obtener la información completa del activo"
          );
        }

        const data = await response.json();

        // 1. Tipos de dominio (opciones del select)
        const opciones = data.tiposActivos.map((item) => ({
          value: item.idtipo_activo,
          label: item.tipo_activo,
        }));
        setOpcionesDominio(opciones);

        // 2. Dominio actual seleccionado
        if (data.activo?.dominio) {
          setDominio({
            value: data.activo.dominio.idtipo_activo,
            label: data.activo.dominio.tipo_activo,
          });
        } else {
          setDominio(null);
        }

        // 3. Información del activo como tal
        setActivo(data.activo);

        // 4. Atributos
        const datActivo = data.atributos;

        if (Array.isArray(datActivo) && datActivo.length > 0) {
          const nuevosValores = {};
          const nuevosPDP = {};
          const indices = [];

          datActivo.forEach((item, index) => {
            const i = index + 1;

            nuevosValores[i] = {
              atributo: item.nombre || "",
              idatributos_activos: item.idatributos_activos || null,
              id_original: item.idatributos_activos || null,
            };

            nuevosPDP[i] = {
              pdp: (item.pdp || 0).toString(),
            };

            indices.push(i);
          });

          setValores(nuevosValores);
          setValoresPDP(nuevosPDP);
          setAtributos(indices);
        } else {
          setValores({});
          setValoresPDP({});
          setAtributos([]);
        }

        // 5. Componentes Relacionados
        if (
          Array.isArray(data.componentesRelacionados) &&
          data.componentesRelacionados.length > 0
        ) {
          setComponentesRelacionados(data.componentesRelacionados);
        } else {
          setComponentesRelacionados([]);
        }
      } catch (error) {
        console.error("Error en obtenerInformacionCompleta:", error);
        setDominio(null);
        setOpcionesDominio([]);
        setActivo([]);
        setValores({});
        setValoresPDP({});
        setAtributos([]);
        setComponentesRelacionados([]);
      }
    };

    const obtenerComponentes = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL +
          "allcomponents/" +
          localStorage.getItem("idcompania") +
          "/1/" + localStorage.getItem("idusuario") + "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token, 
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error al obtener los componentes");
        }

        const data = await response.json();
        const resultComponentes = data.filter(
          (dato) => dato.estadotipoactivo === true
        );

        setModalCompo(resultComponentes);
      } catch (error) {
        console.error("Error en obtenerComponentes:", error);
        // Aquí podrías manejar un estado de error o mostrar mensaje al usuario
      }
    };
    const obtenerProceso = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/procesosxCompania/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datProcesos = await result.json();
      setModalInfo(datProcesos);
    };

    const obtenerCompañias = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "general/compania/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      let datCompania = await result.json();
      let companiaSelect = [];

      companiaSelect = datCompania.map(
        ({ idcompania: value, compania: label }) => ({
          value,
          label,
        })
      );

      setCompaniaDat(companiaSelect);
    };

    const obtenerActivo = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "activoInformacion/" +
        localStorage.getItem("idactivo") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encrypteddatActivo = await result.json();
      const decrypteddatActivo = DecryptData(encrypteddatActivo);
      let datActivo = JSON.parse(decrypteddatActivo);
      let temp = [];
      let temp2 = [];
      let tempRowC = [];
      let tempRowP = [];

      if (datActivo.ComponentesAsociados !== null) {
        for (let i = 0; i < datActivo.ComponentesAsociados.length; i++) {
          const element = datActivo.ComponentesAsociados[i];
          if (element.estadoasociacion == true) {
            tempRowC.push(element);
            temp.push(element.idcomponente);
          }
        }
      }
      if (datActivo.ProcesosAsociados) {
        for (let i = 0; i < datActivo.ProcesosAsociados.length; i++) {
          const element = datActivo.ProcesosAsociados[i];
          if (element.estadoasociacion == true) {
            tempRowP.push(element);
            temp2.push(element.idsubproceso);
          }
        }
      }

      if (datActivo.datos_en_el_activo !== null) {
        setDatContenidos(datActivo.datos_en_el_activo.split(","));
      }
      if (datActivo != null && datActivo.UsuarioResponsableTI !== null) {
        setSelectedValueResponsableTI({
          value: datActivo.idposicionresponsableti,
          label: datActivo.UsuarioResponsableTI,
        });
      }

      const data = await fetch(
        process.env.REACT_APP_API_URL + "general/compania/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      let datCompania = await data.json();
      let nombrecompania = datCompania
        .filter(({ idcompania }) => idcompania == datActivo.idcompania)
        .map(({ compania }) => compania)
        .pop();

      if (datActivo != null && datActivo.idcompania !== null) {
        setSelectedValueCompania({
          value: datActivo.idcompania,
          label: nombrecompania,
        });
      }

      setComponentesSelected(temp);
      setProcesosSelected(temp2);
      setRowsC(tempRowC);
      setRowsCompInit(datActivo.ComponentesAsociados);
      setRowsP(tempRowP);
      setRowsProcInit(datActivo.ProcesosAsociados);
      setNvCriticidad(datActivo.nivel_criticidad);
      setActivo(datActivo);
      setIdState(datActivo.estado);
      if (datActivo.estado == true) {
        setState("Activo");
      } else {
        setState("Inactivo");
      }
    };
    const obtenerUsuariosTI = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "usuariosrolti/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datUsuarios = await result.json();

      let usuariosTI = datUsuarios.map(
        ({ idposicion: value, nombre: label }) => ({
          value,
          label,
        })
      );

      setUsuariosDatTI(usuariosTI);
    };
    const obtenerClasi = async () => {
      try {
        const result = await fetch(
          process.env.REACT_APP_API_URL +
          "activoClasificacion/" +
          localStorage.getItem("idactivo") +
          "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        const data = await result.json();

        if (Array.isArray(data) && data.length > 0) {
          const {
            clasificacion_confidencialidad,
            clasificacion_disponibilidad,
            clasificacion_integridad,
          } = data[0];

          // Setea cada valor por separado
          setConfi(clasificacion_confidencialidad || "");
          setDispo(clasificacion_disponibilidad || "");
          setIntegri(clasificacion_integridad || "");
        } else {
          console.warn("No se encontraron clasificaciones.");
          setConfi("");
          setDispo("");
          setIntegri("");
        }
      } catch (error) {
        console.error("Error al obtener la clasificación:", error);
        setConfi("");
        setDispo("");
        setIntegri("");
      }
    };

    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "usuarios/menu/" +
        localStorage.getItem("usuario") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = [];
      let permisos = [];
      for (let i = 0; i < usuario.length; i++) {
        permisos = usuario[i].permisos.split(";");
        opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
      }
      setOpcionesGenerales(opciones);
      var validity = check.checkPermits(opciones, "PUT");
      if (validity) {
      }
    };

    obtenerClasi();
    obtenerInformacionCompleta();
    obtenerProceso();
    obtenerActivo();
    obtenerUsuariosTI();
    obtenerCompañias();
    obtenerComponentes();
    fetchUsuario();
  }, []);

  useEffect(() => {
    // Solo ejecuta una vez cuando los datos y opciones estén cargadas
    if (
      clasificacionCargada ||
      opcionesConfidencialidad.length === 0 ||
      opcionesClasificacion.length === 0 ||
      !confi ||
      !dispo ||
      !integri // espera que todos estén
    )
      return;

    const nuevaConf = obtenerOpcion(confi, opcionesConfidencialidad);
    const nuevaDisp = obtenerOpcion(dispo, opcionesClasificacion);
    const nuevaInt = obtenerOpcion(integri, opcionesClasificacion);

    if (nuevaConf) setConfidencialidad(nuevaConf);
    if (nuevaDisp) setDisponibilidad(nuevaDisp);
    if (nuevaInt) setIntegridad(nuevaInt);

    // ✅ Marca como cargado solo después de asignar todos los valores
    setClasificacionCargada(true);
  }, [
    opcionesConfidencialidad,
    opcionesClasificacion,
    confi,
    dispo,
    integri,
    clasificacionCargada,
  ]);

  /////// Añadir tags para los componentes asociados
  const removeTag = (i) => {
    const newTags = [...datContenidos];
    newTags.splice(i, 1);
    setDatContenidos(newTags);
  };

  const obtenerOpcion = (valor, opciones) => {
    if (!valor || !Array.isArray(opciones)) return null;
    return opciones.find((op) => op.value === valor) || null;
  };

  // const inputKeyDown = (e) => {
  //   const val = e.target.value;
  //   if (e.key === "Enter" && val) {
  //     e.preventDefault();
  //     setValidated(false);
  //     if (
  //       datContenidos.find((tag) => tag.toLowerCase() === val.toLowerCase())
  //     ) {
  //       return;
  //     }
  //     setDatContenidos([...datContenidos, val]);
  //     let inputTag = document.getElementById("datosSeparados");
  //     inputTag.value = null;
  //   } else if (e.key === "Backspace" && !val) {
  //     removeTag(datContenidos.length - 1);
  //   }
  // };
  const cambiarCriticidad = (conf, disp, integ) => {
    const getPeso = (valor) => {
      const pesos = {
        Crítico: 10,
        Restringida: 10,
        Confidencial: 7,
        Moderado: 5,
        Interna: 5,
        Tolerable: 3,
        Bajo: 1,
        Pública: 1,
      };
      return pesos[valor] || null;
    };

    const pesoConfi = getPeso(conf);
    const pesoDispo = getPeso(disp);
    const pesoInte = getPeso(integ);

    // Si algún valor es null (no válido), clasificar como "No Clasificado"
    if ([pesoConfi, pesoDispo, pesoInte].some((peso) => peso === null)) {
      setNvCriticidad("No Clasificado");
      return;
    }

    const temp = pesoConfi * 0.4 + pesoDispo * 0.3 + pesoInte * 0.3;

    if (temp <= 3.9) {
      setNvCriticidad("Activo Soporte");
    } else if (temp <= 6.9) {
      setNvCriticidad("Activo estratégico");
    } else {
      setNvCriticidad("Activo Crítico");
    }
  };
  const getColorStyle = (valor) => {
    switch (valor) {
      case "Activo Soporte":
        return { backgroundColor: "#198754", color: "white" };
      case "Activo estratégico":
        return { backgroundColor: "#f8f9fa", color: "black" }; // blanco sobre fondo blanco no se ve
      case "Activo Crítico":
        return { backgroundColor: "#8B0000", color: "white" };
      default:
        return {}; // o algún color por defecto
    }
  };

  // const handleChangeState = (event) => {
  //   if (state == "Activo") {
  //     setState("Inactivo");
  //     setIdState(false);
  //   } else {
  //     setState("Activo");
  //     setIdState(true);
  //   }
  // };

  ////////////////////////Crea el componente Select
  const MySelect = (props) => (
    <Select
      {...props}
      className="texto"
      options={props.options}
      placeholder={props.placeholder}
    />
  );

  const sendData = (event) => {
    event.preventDefault();
    setWasSubmitted(true);
    let valid = true;
    // Validación
    if (!dominio || !dominio.value) {
      setErrorDominio(true);
      valid = false;
    } else {
      setErrorDominio(false);
    }
    const nombreActivo = document.getElementById("NombreActivo").value.trim();
    if (nombreActivo === "") {
      setErrorNombreActivo(true);
      valid = false;
    } else {
      setErrorNombreActivo(false);
    }
    if (!selectedValueCompania) {
      setErrorCompania(true);
      valid = false;
    } else {
      setErrorCompania(false);
    }
    if (!selectedValueResponsableTI) {
      setErrorResponsableTI(true);
      valid = false;
    } else {
      setErrorResponsableTI(false);
    }
    if (!componentesRelacionados || componentesRelacionados.length === 0) {
      setErrorAplicaciones(true);
      valid = false;
    } else {
      setErrorAplicaciones(false);
    }

    if (!activoUnico) {
      setErrorActivoUnico(true);
      valid = false;
    } else {
      setErrorActivoUnico(false);
    }

    if (!activoAuditable) {
      setErrorActivoAuditable(true);
      valid = false;
    } else {
      setErrorActivoAuditable(false);
    }
    if (
      confidencialidad &&
      confidencialidad.value !== "" &&
      disponibilidad &&
      disponibilidad.value !== "" &&
      integridad &&
      integridad.value !== ""
    ) {
      setVRequired(false);
    } else {
      setVRequired(true);
      valid = false;
    }
    let erroresAtributos = {};
    atributos.forEach((num) => {
      const atributo = valores[num]?.atributo?.trim() || "";
      const pdp = valoresPDP[num]?.pdp || "";

      if (!atributo || !pdp) {
        valid = false;
        erroresAtributos[num] = {
          atributo: !atributo,
          pdp: !pdp,
        };
      }
    });
    setErrors(erroresAtributos);

    if (!valid) return;
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (form.checkValidity() === true) {
      const timeElapsed = Date.now();
      const today = new Date(timeElapsed);
      let componentesAsociadoTemp = [];
      let rowscT;
      let rowspT;
      let actualizarT = [];
      let actualizarF = [];
      let nuevos = componentesRelacionados; // ✅ Usamos el estado de la tabla

      if (rowsProcInit != null) {
        rowspT = rowsProcInit.filter((dato) => dato.estadoasociacion === true);
      }
      if (rowsCompInit != null) {
        rowscT = rowsCompInit.filter((dato) => dato.estadoasociacion === true);
      }

      // ✅ Filtrar los nuevos (evita duplicar los que ya estaban)
      if (rowsCompInit !== null && nuevos !== null) {
        rowsCompInit.forEach((row) => {
          nuevos = filter(nuevos, (o) => o.idactivo !== row.idcomponente);
          nuevos = filter(nuevos, (o) => o.idcomponente !== row.idcomponente);
        });
      }

      // ✅ Obtener los que deben pasar a estado false
      if (rowscT != null && componentesRelacionados != null) {
        actualizarF = rowscT;
        componentesRelacionados.forEach((row) => {
          actualizarF = filter(
            actualizarF,
            (o) => o.idcomponente !== row.idactivo
          );
        });
      }

      // ✅ Actualizar los que estaban en false y ahora deben pasar a true
      if (rowsCompInit != null) {
        rowsCompInit.forEach((row) => {
          componentesRelacionados.forEach((act) => {
            if (
              row.estadoasociacion === false &&
              row.idcomponente === act.idactivo
            ) {
              actualizarT.push(row);
            }
          });
        });
      }

      // ✅ Procesar cambios a TRUE
      if (actualizarT !== null) {
        actualizarT.forEach((obj) => {
          componentesAsociadoTemp.push({
            idcomponenteasociado: obj.idcomponenteasociado,
            idactivo: obj.idactivo,
            idactivocomponente: obj.idcomponente,
            fechacreacion: obj.fechacreacion,
            estadoasociacion: true,
            idusuariocreacion: obj.idusuariocreacion,
            fechamodificacion: today.toISOString(),
            idusuariomodificacion: obj.idusuariomodificacion,
          });
        });
      }

      // ✅ Procesar cambios a FALSE
      if (actualizarF !== null) {
        actualizarF.forEach((obj) => {
          componentesAsociadoTemp.push({
            idcomponenteasociado: obj.idcomponenteasociado,
            idactivo: obj.idactivo,
            idactivocomponente: obj.idcomponente,
            fechacreacion: obj.fechacreacion,
            estadoasociacion: false,
            idusuariocreacion: obj.idusuariocreacion,
            fechamodificacion: today.toISOString(),
            idusuariomodificacion: obj.idusuariomodificacion,
          });
        });
      }

      // ✅ Procesar nuevos registros
      if (nuevos !== null) {
        nuevos.forEach((obj) => {
          componentesAsociadoTemp.push({
            idcomponenteasociado: obj.idcomponenteasociado,
            idactivo: parseInt(document.getElementById("IDactivo").value),
            idactivocomponente: obj.idactivo,
            fechacreacion: today.toISOString(),
            estadoasociacion: true,
            idusuariocreacion: localStorage.getItem("idusuario"),
            fechamodificacion: today.toISOString(),
            idusuariomodificacion: localStorage.getItem("idusuario"),
          });
        });
      }
      const atributosFormateados = atributos
        .map((num) => {
          const valor = valores[num];
          const pdp = valoresPDP[num];

          if (!valor?.atributo?.trim() || !pdp?.pdp || pdp.pdp === "") {
            return null;
          }

          const atributoData = {
            atributo: valor.atributo.trim(),
            pdp: parseInt(pdp.pdp),
          };

          const tieneIdExistente =
            valor.idatributos_activos &&
            valor.idatributos_activos !== null &&
            valor.idatributos_activos !== undefined &&
            valor.idatributos_activos !== 0;

          if (tieneIdExistente) {
            atributoData.idatributos_activos = valor.idatributos_activos;
          } else {
            atributoData.idatributos_activos = null;
          }

          return atributoData;
        })
        .filter((attr) => attr !== null);

      var data = JSON.stringify({
        idactivo: document.getElementById("IDactivo").value,
        idcompania: parseInt(Object.values(selectedValueCompania)[0]),
        idtipo_activo: 1,
        nombre: document.getElementById("NombreActivo").value,
        idposicionresponsableti: parseInt(
          Object.values(selectedValueResponsableTI)[0]
        ),
        descripcion: document.getElementById("Descripcion").value,
        estado: idState,
        componente_principal: true ? 1 : 0,
        clasificacion_confidencialidad:
          !confidencialidad || !confidencialidad.value
            ? "No Clasificado"
            : confidencialidad.value,

        clasificacion_integridad:
          !integridad || !integridad.value
            ? "No Clasificado"
            : integridad.value,

        clasificacion_disponibilidad:
          !disponibilidad || !disponibilidad.value
            ? "No Clasificado"
            : disponibilidad.value,

        nivel_criticidad: nvCriticidad,
        fechamodificacion: today.toISOString(),
        idusuariomodificacion: localStorage.getItem("idusuario"),
        ComponentesAsociados: componentesAsociadoTemp,
        atributosClasificacion: atributosFormateados,
      });
      console.log("Datos enviados al backend:", JSON.parse(data));

      fetch(
        process.env.REACT_APP_API_URL +
        "evaluacion/activoInformacion/" +
        document.getElementById("IDactivo").value +
        "/",
        {
          method: "PUT",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((data) =>
          data.json().then((response) => {
            if (data.status >= 200 && data.status < 300) {
              setEstadoPost(2);
              localStorage.setItem("idactivo", response.idactivo);
              history.push("/EditarActivo");
            } else if (data.status >= 500) {
              setEstadoPost(5);
              if (
                data.non_field_errors[0] ===
                "The fields idactivo must make a unique set."
              ) {
                setEstadoPost(6);
              }
            } else if (data.status >= 400 && data.status < 500) {
              setEstadoPost(4);
            }
          })
        )
        .catch(function (err) { });
    }
    setValidated(true);
  };

  /////////////Procesos
  function MyVerticallyCenteredModalProcesos(props) {
    const classes = useStylesModal();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("name");
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [queryText, setqueryText] = React.useState("");
    const [procesosTemp, setProcesosTemp] = React.useState(props.procesos);

    // ✅ NUEVO: Estado para mantener los datos completos de los elementos seleccionados
    const [datosSeleccionados, setDatosSeleccionados] = React.useState([]);

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = modalInfo.map((n) => n.idsubproceso);
        setProcesosTemp(newSelecteds);
        // ✅ Actualizar datos seleccionados con todos los elementos
        setDatosSeleccionados(modalInfo);
        return;
      }
      setProcesosTemp([]);
      // ✅ Limpiar datos seleccionados
      setDatosSeleccionados([]);
    };

    const handleClick = (event, id) => {
      const parsedId = String(id);
      const selectedIndex = procesosTemp.indexOf(parsedId);

      let newSelected = [];
      let newDatosSeleccionados = [...datosSeleccionados];

      if (selectedIndex === -1) {
        // ✅ Agregar elemento
        newSelected = [...procesosTemp, parsedId];
        // Encontrar el objeto completo y agregarlo a datosSeleccionados
        const elementoCompleto = modalInfo.find(
          (item) => item.idsubproceso === parsedId
        );
        if (
          elementoCompleto &&
          !newDatosSeleccionados.find((item) => item.idsubproceso === parsedId)
        ) {
          newDatosSeleccionados.push(elementoCompleto);
        }
      } else {
        // ✅ Remover elemento
        newSelected = procesosTemp.filter((x) => x !== parsedId);
        // Remover de datosSeleccionados
        newDatosSeleccionados = newDatosSeleccionados.filter(
          (item) => item.idsubproceso !== parsedId
        );
      }

      setProcesosTemp(newSelected);
      setDatosSeleccionados(newDatosSeleccionados);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };

    const isSelected = (id) => procesosTemp.indexOf(id) !== -1;

    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, modalInfo.length - page * rowsPerPage);

    // ✅ Función para obtener los datos seleccionados (opcional)
    const obtenerDatosSeleccionados = () => {
      return datosSeleccionados;
    };

    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Añadir Procesos asociados al activo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            {/* ✅ OPCIONAL: Mostrar información de elementos seleccionados */}
            <div
              style={{
                marginBottom: "10px",
                padding: "10px",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
              }}
            >
              <strong>
                Elementos seleccionados: {datosSeleccionados.length}
              </strong>
              {datosSeleccionados.length > 0 && (
                <div style={{ fontSize: "12px", marginTop: "5px" }}>
                  {datosSeleccionados.map((item, index) => (
                    <span key={item.idsubproceso}>
                      {item.subproceso}
                      {index < datosSeleccionados.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar"
                    onChange={(e) => setqueryText(e.target.value)}
                    style={{ align: "center" }}
                  />
                </Form>
              </Col>
              <Col sm={4} xs={6}></Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => {
                    // ✅ Ahora puedes pasar tanto los IDs como los datos completos
                    completarTabla(
                      procesosTemp,
                      "procesos",
                      datosSeleccionados
                    );
                  }}
                >
                  Guardar
                </Button>
              </Col>
            </Row>
            <Paper className={classes.paper}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  aria-label="enhanced table"
                >
                  <EnhancedTableHeadProcesos
                    classes={classes}
                    numSelected={procesosTemp.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={modalInfo.length}
                  />
                  <TableBody>
                    {stableSort(modalInfo, getComparator(order, orderBy))
                      .filter((row) =>
                        row.idsubproceso
                          .toLowerCase()
                          .includes(queryText.toLowerCase())
                      )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idsubproceso);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            onClick={(event) =>
                              handleClick(event, row.idsubproceso)
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idsubproceso}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="none"
                            >
                              {row.idsubproceso}
                            </TableCell>
                            <TableCell align="left">
                              {row.macroproceso}
                            </TableCell>
                            <TableCell align="left">{row.proceso}</TableCell>
                            <TableCell align="left">{row.subproceso}</TableCell>
                            <StyledTableCell align="center">
                              <Checkbox
                                inputProps={{ "aria-label": "Checkbox A" }}
                                checked={row.estado}
                                disabled
                              />
                            </StyledTableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={modalInfo.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Vista compacta"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  ///////////// Componentes
  function MyVerticallyCenteredModal(props) {
    const classes = useStylesModal();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("name");
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [queryText, setqueryText] = React.useState("");
    const [contTecno, setContTecno] = React.useState(props.componentes);

    // ✅ NUEVO: Estado para mantener los datos completos de los componentes seleccionados
    const [datosSeleccionados, setDatosSeleccionados] = React.useState([]);

    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = modalCompo.map((n) => n.idevaluacion);
        setContTecno(newSelecteds);
        // ✅ Actualizar datos seleccionados con todos los elementos
        setDatosSeleccionados(modalCompo);
        return;
      }
      setContTecno([]);
      // ✅ Limpiar datos seleccionados
      setDatosSeleccionados([]);
    };

    const handleClick = (event, id) => {
      const parsedId = Number(id);
      const isSelected = contTecno.includes(parsedId);

      let newSelected;
      let newDatosSeleccionados = [...datosSeleccionados];

      if (isSelected) {
        // ✅ Remover elemento
        newSelected = contTecno.filter((item) => item !== parsedId);
        // Remover de datosSeleccionados
        newDatosSeleccionados = newDatosSeleccionados.filter(
          (item) => item.idactivo !== parsedId
        );
      } else {
        // ✅ Agregar elemento
        newSelected = [...contTecno, parsedId];
        // Encontrar el objeto completo y agregarlo a datosSeleccionados
        const elementoCompleto = modalCompo.find(
          (item) => item.idactivo === parsedId
        );
        if (
          elementoCompleto &&
          !newDatosSeleccionados.find((item) => item.idactivo === parsedId)
        ) {
          newDatosSeleccionados.push(elementoCompleto);
        }
      }

      setContTecno(newSelected);
      setDatosSeleccionados(newDatosSeleccionados);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };

    const isSelected = (id) => contTecno.indexOf(id) !== -1;

    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, modalCompo.length - page * rowsPerPage);

    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Añadir componentes tecnológicos asociados al activo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            {/* ✅ OPCIONAL: Mostrar información de elementos seleccionados */}
            <div
              style={{
                marginBottom: "10px",
                padding: "10px",
                backgroundColor: "#f5f5f5",
                borderRadius: "4px",
              }}
            >
              <strong>
                Componentes seleccionados: {datosSeleccionados.length}
              </strong>
              {datosSeleccionados.length > 0 && (
                <div style={{ fontSize: "12px", marginTop: "5px" }}>
                  {datosSeleccionados.map((item, index) => (
                    <span key={item.idactivo}>
                      {item.nombre}
                      {index < datosSeleccionados.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar"
                    onChange={(e) => setqueryText(e.target.value)}
                  />
                </Form>
              </Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  onClick={(e) => crear_com(e)}
                  style={{ marginTop: "1%", width: "100%" }}
                >
                  Crear
                </Button>
              </Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonGeneral"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => {
                    // ✅ Ahora puedes pasar tanto los IDs como los datos completos
                    completarTabla(contTecno, "detalles", datosSeleccionados);
                    setDireccion(false);
                  }}
                >
                  Guardar
                </Button>
              </Col>
            </Row>

            <Paper className={classes.paper}>
              <TableContainer
                component={Paper}
                className={classes.container}
                style={{ overflowX: "auto" }}
              >
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  maxHeightBody="55vh"
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow className={classes.head}>
                      <StyledTableCell padding="checkbox"></StyledTableCell>
                      <StyledTableCell>Id Activo</StyledTableCell>
                      <StyledTableCell>Clase app</StyledTableCell>
                      <StyledTableCell>Código app</StyledTableCell>
                      <StyledTableCell>Nombre</StyledTableCell>
                      <StyledTableCell>Nombre CMD</StyledTableCell>
                      <StyledTableCell>Compañía</StyledTableCell>
                      <StyledTableCell>Tipo de elemento</StyledTableCell>
                      <StyledTableCell>Descripción</StyledTableCell>
                      <StyledTableCell>Responsable</StyledTableCell>
                      <StyledTableCell>Fecha Creación</StyledTableCell>
                      <StyledTableCell>Fecha actualización</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {modalCompo
                      .filter(
                        (row) =>
                          row.nombre
                            ?.toLowerCase()
                            .includes(queryText.toLowerCase()) ||
                          row.idactivo
                            ?.toString()
                            .includes(queryText.toLowerCase())
                      )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idactivo);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            hover
                            onClick={(event) =>
                              handleClick(
                                event,
                                row.idactivo,
                                row.idtipo_activo,
                                row
                              )
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idactivo}
                            selected={isItemSelected}
                          >
                            <StyledTableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </StyledTableCell>
                            <StyledTableCell>{row.idactivo}</StyledTableCell>
                            <StyledTableCell>{row.clase_app}</StyledTableCell>
                            <StyledTableCell>
                              {row.elemento_configuracion}
                            </StyledTableCell>
                            <StyledTableCell>{row.nombre}</StyledTableCell>
                            <StyledTableCell>{row.nombrecmdb}</StyledTableCell>
                            <StyledTableCell>
                              {bCompania(row.idcompania)}
                            </StyledTableCell>
                            <StyledTableCell>
                              {cprincipal(row.componente_principal)}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.tipo_elemento}
                            </StyledTableCell>
                            <StyledTableCell>{row.descripcion}</StyledTableCell>
                            <StyledTableCell>
                              {row.UsuarioResponsableTI}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.fechacreacion}
                            </StyledTableCell>
                            <StyledTableCell>
                              {row.fechamodificacion}
                            </StyledTableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={modalCompo.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  // ✅ Función completarTabla actualizada para recibir los datos completos
  const completarTabla = async (obj, id, datosCompletos = []) => {
    let temp = [];

    switch (id) {
      case "detalles":
        setComponentesSelected(obj);

        // Obtener datos nuevos
        if (datosCompletos && datosCompletos.length > 0) {
          temp = datosCompletos;
        } else {
          for (let i = 0; i < obj.length; i++) {
            const found = modalCompo.find((dato) => dato.idactivo === obj[i]);
            if (found) temp.push(found);
          }
        }

        // ✅ Fusionar con los existentes sin duplicar
        setComponentesRelacionados((prev) => {
          const merged = [...prev, ...temp];
          return merged.filter(
            (item, index, self) =>
              index ===
              self.findIndex(
                (t) =>
                  (t.idcomponente ?? t.idactivo) ===
                  (item.idcomponente ?? item.idactivo)
              )
          );
        });

        setModalShow(false);
        break;

      case "procesos":
        // Si más adelante quieres lo mismo para procesos, aplicas la misma lógica aquí
        break;
    }
  };
  //Fin del Modal

  return (
    <>
      <AlertDismissibleExample alerta={estadoPOST} />
      <MyVerticallyCenteredModal
        componentes={componentesSelected}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <MyVerticallyCenteredModalProcesos
        procesos={procesosSelected}
        show={modalShowProcesos}
        onHide={() => setModalShowProcesos(false)}
      />

      <Row>
        <Col>
          {" "}
          <h2 className="subtitulo">Editar Activo de Información</h2>
        </Col>
      </Row>
      <hr />
      <Form
        id="formData"
        onSubmit={(e) => sendData(e)}
        noValidate
        validated={validated}
      >
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label forn-label">Id Activo de Información</label>
          </Col>
          <Col sm={8} xs={12}>
            <input
              type="text"
              disabled
              className="form-control text-center font-weight-bold"
              defaultValue={activo.idactivo}
              id="IDactivo"
            ></input>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Información de Dominio*</label>
          </Col>
          <Col sm={8} xs={10}>
            <Form.Group>
              <MySelect
                classNamePrefix="react-select"
                className={
                  errorDominio ? "react-select is-invalid" : "react-select"
                }
                value={dominio}
                options={opcionesDominio}
                name="Dominio"
                id="dominio"
                onChange={(e) => {
                  setDominio(e);
                  setErrorDominio(false);
                }}
              />
              {errorDominio && (
                <Form.Control.Feedback type="invalid" className="d-block">
                  Por favor seleccione un Dominio
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">
              Nombre Activo de Información*
            </label>
          </Col>
          <Col sm={8} xs={12}>
            <input
              type="text"
              className="form-control text-center"
              placeholder="Nombre del Activo"
              defaultValue={activo.nombre}
              required
              id="NombreActivo"
            ></input>
            <Form.Control.Feedback type="invalid">
              Por favor introduzca un nombre.
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Descripción</label>
          </Col>
          <Col sm={8} xs={12}>
            <textarea
              className="form-control text-center"
              placeholder="Descripción del activo de información"
              rows="3"
              id="Descripcion"
              defaultValue={activo.descripcion}
            ></textarea>
          </Col>
        </Row>
        <Row className="mb-3"></Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Compañía*</label>
          </Col>
          <Col sm={8} xs={10}>
            <MySelect
              placeholder={"Seleccione la compañía..."}
              options={companiaDat}
              value={selectedValueCompania}
              onChange={(e) => {
                onChangeCompania(e); // función para manejar el cambio (ej. actualizar estado general)
                setErrorCompania(false); // limpio el error
                setSelectedValueCompania(e); // actualizo el estado local para la selección
              }}
              styles={stylesSelect}
              className={errorCompania ? "is-invalid" : ""}
              classNamePrefix="react-select"
            />
            {errorCompania && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione una compañía.
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Responsable</label>
          </Col>
          <Col sm={8} xs={10}>
            <div className={errorResponsableTI ? "is-invalid" : ""}>
              <MySelect
                placeholder={"Seleccione el responsable..."}
                options={usuariosDatTI}
                value={selectedValueResponsableTI}
                onChange={(e) => {
                  onChangeResponsableTI(e);
                  setSelectedValueResponsableTI(e);
                  setErrorResponsableTI(false);
                }}
                styles={stylesSelect}
                classNamePrefix="react-select"
              />
            </div>
            {errorResponsableTI && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione un responsable.
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">
              Protección de Datos Personales
            </label>
          </Col>
          <Col sm={8} xs={10}>
            <MySelect
              placeholder="Seleccione..."
              options={[
                { value: "SI", label: "SI" },
                { value: "NO", label: "NO" },
              ]}
            />
          </Col>
        </Row>
        <Row className="mb-3 align-items-center">
          <Col sm={4} xs={15}>
            <label className="label form-label fs-3">
              ¿El activo es único en tu Dominio de información?*
            </label>
          </Col>
          <Col sm={4} xs={12}>
            <div className={errorActivoUnico ? "is-invalid" : ""}>
              <Select
                placeholder="Seleccione SI/NO"
                options={[
                  { value: "SI", label: "SI" },
                  { value: "NO", label: "NO" },
                ]}
                name="activoUnico"
                id="activoUnico"
                styles={stylesSelect}
                onChange={(selected) => {
                  setActivoUnico(selected);
                  setErrorActivoUnico(false);
                }}
                classNamePrefix="react-select"
              />
            </div>
            {errorActivoUnico && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione SI/NO
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>

        <Row className="mb-3 align-items-center">
          <Col sm={4} xs={15}>
            <label className="label form-label fs-3">
              ¿El activo es completo y auditable?*
            </label>
          </Col>
          <Col sm={4} xs={12}>
            <div className={errorActivoAuditable ? "is-invalid" : ""}>
              <Select
                placeholder="Seleccione SI/NO"
                options={[
                  { value: "SI", label: "SI" },
                  { value: "NO", label: "NO" },
                ]}
                name="activoAuditable"
                id="activoAuditable"
                styles={stylesSelect}
                onChange={(selected) => {
                  setActivoAuditable(selected);
                  setErrorActivoAuditable(false);
                }}
                classNamePrefix="react-select"
              />
            </div>
            {errorActivoAuditable && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione SI/NO
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={3} xs={5} className="text-left">
            <label className="label form-label">
              Clasificación Confidencialidad
            </label>
          </Col>
          <Col sm={3} xs={5}>
            <MySelect
              inputId="Confidencialidad"
              value={confidencialidad || null}
              onChange={(val) => {
                setConfidencialidad(val);
                const confi = val?.value || "";
                const dispo = disponibilidad?.value || "";
                const inte = integridad?.value || "";
                cambiarCriticidad(confi, dispo, inte);
              }}
              options={opcionesConfidencialidad}
              placeholder="Seleccione una opción"
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor:
                    wasSubmitted &&
                      (!confidencialidad || confidencialidad.value === "")
                      ? "red"
                      : base.borderColor,
                  boxShadow: "none",
                  "&:hover": {
                    borderColor:
                      wasSubmitted &&
                        (!confidencialidad || confidencialidad.value === "")
                        ? "red"
                        : base.borderColor,
                  },
                }),
              }}
            />
            {wasSubmitted &&
              (!confidencialidad || confidencialidad.value === "") && (
                <div style={{ color: "red", fontSize: "0.8rem", marginTop: 4 }}>
                  Por favor seleccione un valor válido para confidencialidad
                </div>
              )}
          </Col>

          <Col sm={3} xs={5} className="text-left">
            <label className="label form-label">
              Clasificación disponibilidad
            </label>
          </Col>
          <Col sm={3} xs={5}>
            <MySelect
              inputId="Disponibilidad"
              value={disponibilidad || null}
              onChange={(val) => {
                setDisponibilidad(val);
                const confi = confidencialidad?.value || "";
                const dispo = val?.value || "";
                const inte = integridad?.value || "";
                cambiarCriticidad(confi, dispo, inte);
              }}
              options={opcionesClasificacion}
              placeholder="Seleccione una opción"
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor:
                    wasSubmitted &&
                      (!disponibilidad || disponibilidad.value === "")
                      ? "red"
                      : base.borderColor,
                  boxShadow: "none",
                  "&:hover": {
                    borderColor:
                      wasSubmitted &&
                        (!disponibilidad || disponibilidad.value === "")
                        ? "red"
                        : base.borderColor,
                  },
                }),
              }}
            />
            {wasSubmitted &&
              (!disponibilidad || disponibilidad.value === "") && (
                <div style={{ color: "red", fontSize: "0.8rem", marginTop: 4 }}>
                  Por favor seleccione un valor válido para disponibilidad
                </div>
              )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={3} xs={5}>
            <label className="label form-label">Clasificación integridad</label>
          </Col>
          <Col sm={3} xs={5}>
            <MySelect
              inputId="Integridad"
              value={integridad || null}
              options={opcionesClasificacion}
              onChange={(val) => {
                setIntegridad(val);
                const confi = confidencialidad?.value || "";
                const dispo = disponibilidad?.value || "";
                const inte = val?.value || "";
                cambiarCriticidad(confi, dispo, inte);
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor:
                    wasSubmitted && (!integridad || integridad.value === "")
                      ? "red"
                      : base.borderColor,
                  boxShadow: "none",
                  "&:hover": {
                    borderColor:
                      wasSubmitted && (!integridad || integridad.value === "")
                        ? "red"
                        : base.borderColor,
                  },
                }),
              }}
            />
            {wasSubmitted && (!integridad || integridad.value === "") && (
              <div style={{ color: "red", fontSize: "0.8rem", marginTop: 4 }}>
                Por favor seleccione un valor válido para integridad
              </div>
            )}
          </Col>

          <Col sm={3} xs={5} className="text-left">
            <label className="label form-label">Nivel de criticidad</label>
          </Col>
          <Col sm={3} xs={5} className="d-flex align-items-center">
            <input
              disabled
              type="text"
              className="form-control text-center colorAuto"
              placeholder="Calculado Automático"
              id="Criticidad"
              value={nvCriticidad}
              style={getColorStyle(nvCriticidad)}
            />
          </Col>
        </Row>

        <div className="border rounded p-3 bg-light mb-4">
          {/* Título principal */}
          <Row className="mb-3 align-items-center">
            <Col className="d-flex align-items-center gap-2">
              <label className="label form-label mb-0">Atributos*</label>
            </Col>
          </Row>

          {/* Encabezados de columnas */}
          <Row className="mb-2">
            <Col sm={3} xs={12}></Col>
            <Col sm={4} xs={12}>
              <label className="form-label fw-bold">Nombre del atributo</label>
            </Col>
            <Col sm={4} xs={12}>
              <label className="form-label fw-bold">
                Protección Datos Personales
              </label>
            </Col>
            <Col sm={1}></Col>
          </Row>

          {/* Campos dinámicos */}
          {atributos.map((num) => (
            <Row className="mb-3" key={`atributo-${num}`}>
              <Col sm={3} xs={12}>
                <label className="label form-label">{`Atributo ${num}`}</label>
              </Col>

              <Col sm={4} xs={12}>
                <input
                  type="text"
                  className={`form-control ${errors[num]?.atributo ? "is-invalid" : ""
                    }`}
                  placeholder={`Nombre del atributo ${num}`}
                  id={`atributoNombre${num}`}
                  name={`atributoNombre${num}`}
                  value={valores[num]?.atributo || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValores((prev) => ({
                      ...prev,
                      [num]: {
                        ...prev[num],
                        atributo: value,
                      },
                    }));
                  }}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Por favor escribe el nombre del Atributo
                </Form.Control.Feedback>
              </Col>

              <Col sm={4} xs={12}>
                <select
                  className={`form-control ${errors[num]?.pdp ? "is-invalid" : ""
                    }`}
                  id={`pdp${num}`}
                  name={`pdp${num}`}
                  value={valoresPDP[num]?.pdp || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValoresPDP((prev) => ({
                      ...prev,
                      [num]: {
                        ...prev[num],
                        pdp: value,
                      },
                    }));
                  }}
                  required
                >
                  <option value="">Seleccione</option>
                  <option value="1">SI</option>
                  <option value="0">NO</option>
                </select>
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione SI/NO
                </Form.Control.Feedback>
              </Col>

              {num > 5 && (
                <Col sm={1} xs={12} className="d-flex align-items-center">
                  <Button
                    type="button"
                    variant="danger"
                    size="sm"
                    onClick={() => eliminarAtributo(num)}
                  >
                    Eliminar
                  </Button>
                </Col>
              )}
            </Row>
          ))}

          <Row>
            <Col>
              <Button
                type="button"
                className="botonPositivo"
                onClick={agregarAtributo}
              >
                <AddIcon fontSize="small" /> Agregar atributo
              </Button>
            </Col>
          </Row>
        </div>
        <Row className="mb-3">
          <Col md={10}>
            <h3 style={{ color: errorAplicaciones ? "#dc3545" : "inherit" }}>
              Aplicaciones asociadas al activo de información
              {errorAplicaciones && (
                <span style={{ color: "#dc3545" }}> *</span>
              )}
            </h3>
            {errorAplicaciones && (
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "0.875em",
                  marginTop: "5px",
                }}
              >
                Debe agregar al menos una aplicación asociada
              </div>
            )}
          </Col>
          <Col md={2}>
            <Button className="botonIngreso" onClick={() => setModalShow(true)}>
              Añadir
            </Button>
          </Col>
        </Row>

        <Row className="mb-3">
          <TableContainer
            component={Paper}
            className="table table-bordered"
            style={{
              border: errorAplicaciones ? "2px solid #dc3545" : "inherit",
              borderRadius: "4px",
            }}
          >
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="left" style={{ color: "white" }}>
                    ID
                  </StyledTableCell>
                  <StyledTableCell align="left" style={{ color: "white" }}>
                    Nombre
                  </StyledTableCell>
                  <StyledTableCell align="left" style={{ color: "white" }}>
                    Tipo de Componente
                  </StyledTableCell>
                  <StyledTableCell align="left" style={{ color: "white" }}>
                    Evaluado
                  </StyledTableCell>
                  <StyledTableCell align="left" style={{ color: "white" }}>
                    BIA
                  </StyledTableCell>
                  <StyledTableCell align="left" style={{ color: "white" }}>
                    SOX
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {componentesRelacionados.length === 0 ? (
                  <StyledTableRow>
                    <StyledTableCell
                      colSpan={4}
                      align="center"
                      style={{
                        color: errorAplicaciones ? "#dc3545" : "#6c757d",
                        fontStyle: "italic",
                        padding: "20px",
                      }}
                    >
                      {errorAplicaciones
                        ? "No hay aplicaciones asociadas. Debe agregar al menos una."
                        : "No hay aplicaciones asociadas"}
                    </StyledTableCell>
                  </StyledTableRow>
                ) : (
                  componentesRelacionados.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        {row.idcomponente == undefined
                          ? row.idactivo
                          : row.idcomponente}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.componenteprincipal == !null
                          ? row.nombrecomponente
                          : row.nombre}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.componente_principal === 0
                          ? "Infraestructura"
                          : row.componente_principal === 1
                            ? "Principal"
                            : row.componente_principal === 2 ? "Modulo" : ""}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.efecto === "SI" ? (
                          <CheckCircleIcon sx={{ color: green[400] }} />
                        ) : row.efecto === "NO" ? (
                          <CancelIcon sx={{ color: red[400] }} />
                        ) : (
                          row.efecto 
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.bia === true ? "Sí" : "No"}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        {row.sox === true ? "Sí" : "No"}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={1}></Col>
          <Col sm={3} xs={3}>
            {" "}
            {/* <a href="EditarActivo"> */}
            {check.checkPermits(opcionesGenerales, "POST") ? (
              <Button type="submit" className="botonPositivo" id="send">
                Guardar
              </Button>
            ) : (
              ""
            )}
            {/* </a> */}
          </Col>
          <Col sm={3} xs={3}>
            <Link to="decisiones">
              <Button className="botonNegativo">Descartar</Button>
            </Link>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <br />
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default EditarComponente;
